import { all, takeLatest, call, put } from "redux-saga/effects";
import { INVEST_CHECKOUT, CREATE_FUND } from "./constant";
import * as api from "../../../utils/api";
import { API_URL } from "../../../utils/axios";
import { v4 as uuidv4 } from "uuid";
import { setStep } from "../../../globalRedux/actions";
import { investCheckoutSuccess, investCheckoutFailed } from "./actions";
import { setRSPPayload } from "../../deposit/redux/action";
import { resetSelectedPromo } from "../../promoList/redux/action";
import { setLastAmountInvest } from "../../fundSelectionStep2/redux/actions";

export function* investCheckoutSaga({ payload }) {
  try {
    let {
      customerChannelCode,
      amount,
      ccy,
      cifId,
      name,
      email,
      funds = [],
      cifPlanId,
      campaignCode,
      productCatCd,
      source,
      sourceType
    } = payload;

    const checkoutPayload = {
      cifPlanId,
      campaignCode,
      trxType: "FPX",
      unit: 0,
      feePercent: 0,
      feeCcy: "MYR",
      feeAmount: 0,
      paymentTypeCd: "",
      ppgRefNo: "",
      pgRefNo: "",
      type: "Buy",
      status: "",
      funds,
      source,
      sourceType
    };

    const resCheckout = yield call(
      api.post,
      `${API_URL.mpV2}/checkout`,
      checkoutPayload
    );

    const trxRefNo = resCheckout?.data?.trxRefNo;

    const generatePayload = {
      trxRefNo,
      cifID: cifId,
      customerChannelCode,
      name,
      email,
      amount,
      ccy,
    };

    const resGenerate = yield call(
      api.post,
      `${API_URL.ppg}/payment/generate`,
      generatePayload
    );

    const { data } = resGenerate;

    const ppgPostDirect = {
      customerChannelCode,
      payCatCd: null,
      trxRefNo,
      amount,
      ccy,
      cifID: cifId,
      refId: productCatCd,
      name,
      email,
      lang: "en",
      signature: data.signature,
      resUrl: `${API_URL.mp}/webhooks/res-url`,
      backUrl: `${API_URL.backURL}`,
    };

    const myForm = document.createElement("form");
    myForm.method = "POST";
    myForm.id = "Payform";
    myForm.action = `${API_URL.ppg}/entry`;

    for (const key in ppgPostDirect) {
      if (Object.hasOwnProperty.call(ppgPostDirect, key)) {
        const element = ppgPostDirect[key];
        const myInput = document.createElement("input");
        myInput.type = "hidden";
        myInput.name = key;
        myInput.id = key;
        myInput.value = element;
        myForm.appendChild(myInput);
      }
    }
    document.body.appendChild(myForm);
    yield put(setStep(null));

    // set dashboard tab upon redirection to mp
    localStorage.setItem(
      "currentTab",
      JSON.stringify(
        productCatCd && productCatCd === "MPRetire"
          ? {
              id: 3,
              name: "Retirement",
            }
          : {
              id: 2,
              name: "Invest",
            }
      )
    );

    yield put(setLastAmountInvest());
    yield put(resetSelectedPromo());
    myForm.submit();
  } catch (error) {
    yield put(investCheckoutFailed(error));
  } finally {
    if (payload?.funds?.length > 1) {
      // for removing deeplink plan persisted selected funds
      localStorage.removeItem("currentPlan");
      yield put(setLastAmountInvest());
    }
  }
}

export function* investCheckoutWorker() {
  yield all([takeLatest(INVEST_CHECKOUT, investCheckoutSaga)]);
}
